import resource from '@/utils/pages/resources';

export default resource({
  namespace: ['site'],
  store: { url: 'site/users' },
  name: 'user',
  key: 'email',
  creatable: false,
  deletable: false,
  attributes: [
    ['email', { form: { validate: { required: true, email: true } } }],
    ['active', { type: 'boolean' }],
  ],
  // form: {
  //   fields: [
  //     ['password', { required: true }],
  //   ],
  // },
  table: {
    defaultSort: [['createdAt', 'desc']],
  },
});
